import React, {
	useCallback,
	useEffect,
	useMemo,
	useRef,
	useState,
} from "react";
import { AgGridReact } from "ag-grid-react";
import api from "../../utils/axios";
import { ColDef } from "ag-grid-enterprise";
import FilterSection from "../../components/FilterOrderSection";
import {
	codeFormatter,
	valueDateFormatter,
	currencySymbol,
	formatMoney,
} from "../../utils/formatters";
import useCurrencies from "../../hooks/useCurrencies";
import "./index.css";
import { Button, Divider, Modal, Steps } from "antd";
import DefaultInput from "../../components/form/DefaultInput";
import { useLocation } from "react-router-dom";
import { getUserRoleFromToken } from "../../utils/Auth";
import { fetchAllUsers } from "../../lib/UserApi";
import useOnDemand from "../../hooks/useOnDemand";
import PaginationTable from "../../components/Pagination";
import DefaultSelect from "../../components/form/DefaultSelect";
import { MapContainer, Marker, Popup, TileLayer, useMap } from "react-leaflet";
import L, { Icon, LatLngExpression, LatLngTuple } from "leaflet";
import "leaflet/dist/leaflet.css";
import "../Buyer/index.css";
import { toast } from "react-toastify";
import { ReactComponent as InfoIcon } from "../../assets/info-circle-filled.svg";
import { ReactComponent as DriverIcon } from "../../assets/driverIcon.svg";
import { ReactComponent as Exchange } from "../../assets/Exchange1.svg";
import { ReactComponent as Invoice } from "../../assets/Invoice1.svg";
import { ReactComponent as Returnable } from "../../assets/Returnable.svg";
import { UserOutlined } from "@ant-design/icons";
import classes from "../Arrangments/PriceConfigurations.module.css";
import DefaultPhoneInput from "../../components/form/DefaultPhoneInput";
import { useConfiguration } from "../../hooks/useConfiguration";
import { ConfigurationId } from "../../types/Lookups";
import { fetchZonesCached } from "../../lib/cachedLookups";
import { useCustomsOptions } from "../../hooks/useCustomsOptions";
import OrderDetailRow from "../../components/form/OrderDetailRow";
import Buttons from "../../components/form/Buttons";
import { orderStatuses, userRoles } from "../../types/enums";
import { navigateToClientDetails } from "../../utils/navigateToClientDetails";
import useLang from "../../hooks/useLang";
import { useMediaQuery } from "@mui/material";
import { hasAccess } from "../../lib/MenuValidation";
import OrderStatusModal from "./OrderStatusChangeModal";
import { CONFIG } from "../../config";
import AddressSelect from "../../components/form/AddressSelect";

const getValueFromOption = (value: string) => {
	if (value?.toString().includes("-")) {
		return value.split("-")[0];
	}
	return value;
};

const Orders = () => {
	const { dualCurrencyEnabled } = useCurrencies();
	let defaultExcelExportSettings = {};
	const defaultColDef = useMemo(
		() => ({
			sortable: true,
			filter: true,
			wrapHeaderText: true,
			resizable: true,
			filterParams: { excelMode: "windows" },
			autoSizeAllColumns: true,
		}),
		[]
	);
	const location = useLocation();
	const statusFilter = location.state?.statusFilter;

	const statusFilters = Array.isArray(statusFilter) ? statusFilter : [];
	const [filterData, setFilterData] = useState<any>({
		statusIds: statusFilters,
	});

	let grid = useRef<AgGridReact | null>(null);
	const [tableData, setTableData] = useState<any[]>([]);
	const [tableColumns, setTableColumns] = useState<ColDef[]>();
	const [orderRedirectModalOpen, setOrderRedirectModalOpen] =
		useState<boolean>(false);
	const [orderDetailsModalOpen, setOrderDetailsModalOpen] =
		useState<boolean>(false);
	const [changeOrderPriceOpen, setChangeOrderPriceOpen] =
		useState<boolean>(false);
	const [openOrderHistory, setOpenOrderHistory] = useState<boolean>();
	const [isWaitingForPickupModalOpen, setIsWaitingForPickupModalOpen] =
		useState<boolean>(false);
	const [rowData, setRowData] = useState<any>();
	const [orderHistory, setOrderHistory] = useState<any[]>([]);
	const [filterButtonLoading, setFilterButtonLoading] =
		useState<boolean>(false);
	const [name, setName] = useState<string | undefined>();
	const [lastName, setLastName] = useState<string | undefined>();
	const [phone, setPhone] = useState<string | undefined>();
	const [address, setAddress] = useState<string | undefined>();
	const [country, setCountry] = useState<string | null>(null);
	const [city, setCity] = useState<string | undefined>();
	const [countryDropDown, setCountryDropDown] = useState<any>([]);
	const [cityDropDown, setCityDropDown] = useState<any>([]);
	const [cities, setCities] = useState<any>([]);

	const [latitude, setLatitude] = useState<number | null>(null);
	const [longitude, setLongitude] = useState<number | null>(null);
	const [error, setError] = useState<string | null>(null);
	const [mapCenter, setMapCenter] = useState<LatLngTuple | null>(null);
	const markerRef = useRef(null);
	const [position, setPosition] = useState<any>(null);
	const [adressPosition, setAddressPosition] = useState<any>(null);
	const [sectionId, setSectionId] = useState<number>();
	const [loading, setLoading] = useState(true);
	const [geoData, setGeoData] = useState<any>();
	const [countryLabel, setCountryLabel] = useState<string>("xk");
	const [cityLabel, setCityLabel] = useState<string | undefined>("");
	const [apiLatitude, setApiLatitude] = useState<number | null>();
	const [apiLongitude, setApiLongitude] = useState<number | null>();
	// Known from the token on the first render, so the filter bar never loads the admin-only
	// client and staff lists for a client.
	const [isClient, setIsClient] = useState<boolean>(() => {
		const roleId = getUserRoleFromToken();
		return roleId === userRoles.CLIENT || roleId === userRoles.SUBCLIENT;
	});
	const [isBulkStatusChangeModalVisible, setIsBulkStatusChangeModalVisible] =
		useState<boolean>(false);
	const [orderPrice, setOrderPrice] = useState<any>("0");
	const [selectedOrderIds, setSelectedOrderIds] = useState<any[]>([]);
	const [transportCost, setTransportCost] = useState("");
	const [modalTransportPrice, setModalTransportPrice] = useState(false);
	const [newOrderPriceForReturn, setNewOrderPriceForReturn] =
		useState<number>(0);

	const [customsId, setCustomsId] = useState<number | null>(null);
	const customs = useCustomsOptions();
	const defaultSystemCountryId =
		useConfiguration(ConfigurationId.Country) ?? "";
	const [waitingPickupOrderList, setWaitingPickupOrderList] = useState<any>(
		[]
	);
	const [
		openChangeStatusToPreviousModal,
		setOpenChangeStatusToPreviousModal,
	] = useState<boolean>(false);
	const [isSubmitting, setIsSubmitting] = useState(false);
	// Every user, for the bulk status window only: loaded the first time it opens instead of on
	// every visit to this page.
	const { data: allUsers, load: loadAllUsers } = useOnDemand(fetchAllUsers);
	const { strings } = useLang("filterorder");

	const canChangeOrderValue = hasAccess("ORDER_VALUE_CHANGE_ACCESS");
	const hasAccessToHarleyTickets = hasAccess("HARLEY_TICKETS_ACCESS");
	const hasAccessToSellers = hasAccess("ORDER_DETAILS_SELLER_ACCESS");
	const accessToOrderTransportPrice = hasAccess(
		"ORDER_DETAILS_ORDER_TRANSPORT_PRICE_ACCESS"
	);
	const hasBulkOrderStatusPermission = hasAccess(
		"ORDER_STATUS_CHANGE_BULK_ACCESS"
	);

	const hexToRgba = (hex: string, alpha: number) => {
		const r = parseInt(hex.slice(1, 3), 16);
		const g = parseInt(hex.slice(3, 5), 16);
		const b = parseInt(hex.slice(5, 7), 16);
		return `rgba(${r},${g},${b},${alpha})`;
	};

	const fetchGeoData = useCallback(async (latitude: any, longitude: any) => {
		try {
			const response = await api.get("External/get-geo-data", {
				params: {
					lng: longitude,
					lat: latitude,
					category: CONFIG?.zoneShofer ?? "",
				},
			});
			if (response.status === 200) {
				const result = response?.data;
				setSectionId(result.geofences[0]?.name as number);
				setGeoData(response.data);
			}
		} catch (error) {
			console.log(error);
		}
	}, []);

	// Reloads the current page with the filters in place, after an action on the grid. Same
	// argument order as handleFilterSubmit: it used to shift seller, staff, settled and order type
	// one slot each and read `displayId` / `fromData`, which do not exist, so a reload dropped or
	// scrambled the filters.
	const fetchTableData = async () => {
		getOrders(
			pageSize,
			currentPage,
			filterData?.countryIds,
			filterData?.cityIds,
			filterData?.statusIds,
			filterData?.displayIds,
			filterData?.orderDescription,
			filterData?.fromDate,
			filterData?.toDate,
			filterData?.filterType,
			filterData?.orderTypeFilter,
			filterData?.sellerIds,
			filterData?.staffIds,
			filterData?.selectedSettled
		);
	};

	const fetchOrders = async (
		pageSize: number,
		currentPage: number,
		countryIds?: any[],
		cityIds?: any[],
		statusIds?: any[],
		displayId?: any,
		orderDescription?: any,
		fromDate?: any,
		toDate?: any,
		filterType?: any,
		orderTypeFilter?: any,
		sellerIds?: any[],
		staffIds?: any[],
		selectedSettled?: boolean,
		paginationDisabled?: boolean
	) => {
		const displayIdSearchTerm = displayId || null;
		const response = await api.post("Order/allorders-filter-pagination", {
			pageSize,
			currentPage,
			countryIds:
				countryIds?.map((c) => ({
					id: getValueFromOption(c),
				})) || [],
			cityIds: cityIds?.map((c) => ({ id: getValueFromOption(c) })) || [],
			statusIds:
				statusIds?.map((c) => ({
					id: getValueFromOption(c),
				})) || [],
			displayId,
			orderDescription,
			fromDate,
			toDate,
			filterType,
			orderTypeFilter: orderTypeFilter || null,
			sellerIds:
				sellerIds?.map((c) => ({
					id: getValueFromOption(c),
				})) || [],
			staffIds:
				staffIds?.map((c) => ({ id: getValueFromOption(c) })) || [],
			settled: selectedSettled,
			paginationDisabled,
			displayIdSearchTerm,
		});
		return response.data;
	};
	const fetchOrdersCount = async (
		pageSize: number,
		currentPage: number,
		countryIds?: any[],
		cityIds?: any[],
		statusIds?: any[],
		displayId?: any,
		orderDescription?: any,
		fromDate?: any,
		toDate?: any,
		filterType?: any,
		orderTypeFilter?: any,
		sellerIds?: any[],
		staffIds?: any[],
		selectedSettled?: boolean,
		paginationDisabled?: boolean
	) => {
		const displayIdSearchTerm = displayId || null;
		const response = await api.post(
			"Order/allorders-filter-pagination-count",
			{
				pageSize,
				currentPage,
				countryIds:
					countryIds?.map((c) => ({
						id: getValueFromOption(c),
					})) || [],
				cityIds:
					cityIds?.map((c) => ({ id: getValueFromOption(c) })) || [],
				statusIds:
					statusIds?.map((c) => ({
						id: getValueFromOption(c),
					})) || [],
				displayId,
				orderDescription,
				fromDate,
				toDate,
				filterType,
				orderTypeFilter: orderTypeFilter || null,
				sellerIds:
					sellerIds?.map((c) => ({
						id: getValueFromOption(c),
					})) || [],
				staffIds:
					staffIds?.map((c) => ({ id: getValueFromOption(c) })) || [],
				settled: selectedSettled,
				paginationDisabled,
				displayIdSearchTerm,
			}
		);
		return response.data;
	};
	const getOrders = async (
		pageSize: number,
		currentPage: number,
		countryIds?: any[],
		cityIds?: any[],
		statusIds?: any[],
		displayId?: any,
		orderDescription?: any,
		fromDate?: any,
		toDate?: any,
		filterType?: any,
		orderTypeFilter?: any,
		sellerIds?: any[],
		staffIds?: any[],
		selectedSettled?: boolean,
		paginationDisabled?: boolean
	) => {
		try {
			setFilterButtonLoading(true);
			var orderTypeFilterBug = null;
			if (
				orderTypeFilter !== "returnable" &&
				orderTypeFilter !== "exchangeable" &&
				orderTypeFilter !== "re_directed"
			) {
				orderTypeFilterBug = null;
			} else {
				orderTypeFilterBug = orderTypeFilter;
			}
			const responseData = await fetchOrders(
				pageSize,
				currentPage,
				countryIds,
				cityIds,
				statusIds,
				displayId,
				orderDescription,
				fromDate,
				toDate,
				filterType,
				(orderTypeFilter = orderTypeFilterBug),
				sellerIds,
				staffIds,
				selectedSettled,
				paginationDisabled
			);
			setTableData(responseData?.data);
			const totalResponseData = await fetchOrdersCount(
				pageSize,
				currentPage,
				countryIds,
				cityIds,
				statusIds,
				displayId,
				orderDescription,
				fromDate,
				toDate,
				filterType,
				orderTypeFilter,
				sellerIds,
				staffIds,
				selectedSettled,
				paginationDisabled
			);
			setTotal(totalResponseData?.total);
			setFilterButtonLoading(false);

			return responseData;
		} catch (err) {
			setFilterButtonLoading(false);
			console.log(err);
		}
	};

	const fetchOrderHistory = async (orderId: string) => {
		try {
			const response = await api.get("Order/short-order-history", {
				params: {
					orderId: orderId,
				},
			});
			const result = response.data.reverse();
			setOrderHistory(result);
		} catch (error) {
			console.log("Error:", error);
		}
	};

	const userRoleId = getUserRoleFromToken();

	const onFilterOrders = (
		countryIds: any[],
		cityIds: any[],
		statusIds: any[],
		displayIds: any[],
		orderDescription: any,
		fromDate: any,
		toDate: any,
		filterType: any,
		orderTypeFilter: any,
		sellerIds: any[],
		staffIds: any[],
		selectedSettled: boolean | undefined
	) => {
		setFilterData({
			countryIds,
			cityIds,
			statusIds,
			displayIds,
			orderDescription,
			fromDate,
			toDate,
			filterType,
			orderTypeFilter,
			sellerIds,
			staffIds,
			selectedSettled,
		});
		//setCurrentPage(1);
	};
	const handleFilterSubmit = () => {
		getOrders(
			pageSize,
			1,
			filterData.countryIds,
			filterData.cityIds,
			filterData.statusIds,
			filterData.displayIds,
			filterData.orderDescription,
			filterData.fromDate,
			filterData.toDate,
			filterData.filterType,
			filterData.orderTypeFilter,
			filterData.sellerIds,
			filterData.staffIds,
			filterData.selectedSettled
		);
		setCurrentPage(1);
	};

	const isSmallScreen = useMediaQuery("(max-width: 994px)");

	// Data loads once on open. They used to share the column effect below, so every change of
	// `strings` or `dualCurrencyEnabled` reloaded the grid, the counts and the user list.
	useEffect(() => {
		fetchTableData();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (!strings) {
			return;
		}
		userRoleId === userRoles.CLIENT || userRoleId === userRoles.SUBCLIENT
			? setIsClient(true)
			: setIsClient(false);

		if (userRoleId === userRoles.ADMIN) {
			customOptions.push({
				label: strings?.labels?.changeTransportPrice,
				value: "changeTransportPrice",
			});
		}
		setTableColumns([
			{
				headerCheckboxSelection: true,
				checkboxSelection: true,
				width: 40,
				suppressSizeToFit: isSmallScreen,
			},
			{
				field: "displayId",
				headerName: strings?.code,
				valueFormatter: (params) => codeFormatter(params.value),
				suppressSizeToFit: isSmallScreen,
				cellRendererFramework: (params: any) => {
					const test = codeFormatter(params.value);
					return (
						<div className="flex flex-col justify-center leading-tight">
							<div className="flex flex-row gap-2 items-center">
								<p style={{ textDecoration: "underline" }}>
									{test}
								</p>
								{params.data.exchangeable && (
									<div>
										<Exchange />
									</div>
								)}
								{params.data.returnable && (
									<div>
										<Returnable />
									</div>
								)}
								{params.data.invoice && (
									<div>
										<Invoice />
									</div>
								)}
							</div>
							{params.data.createdByUsername && (
								<div
									className="flex flex-row gap-1 items-center"
									style={{
										fontSize: "11px",
										color: "#6B7280",
										textDecoration: "none",
										marginTop: "6px",
									}}
								>
									<UserOutlined
										style={{ fontSize: "11px" }}
									/>
									<span style={{ textDecoration: "none" }}>
										{params.data.createdByUsername}
									</span>
								</div>
							)}
						</div>
					);
				},
				cellStyle: (params: any) => ({
					fontSize: "15px",
					fontWeight: "400",
					lineHeight: "18px",
					color: "#4F16C2",
				}),
				width: 140,
			},
			{
				field: "refid",
				headerName: strings?.reference,
				width: 120,
				suppressSizeToFit: isSmallScreen,
			},
			{
				field: "statusDescription",
				headerName: strings?.status,
				cellRendererFramework: (params: any) => {
					const statusColorHexCode =
						params.data.statusColorHexCode || "#ffff";
					const rgbaColor = hexToRgba(statusColorHexCode, 0.08);
					return (
						<div className="statusStyle">
							<div
								className="statusValues"
								style={{
									backgroundColor: rgbaColor,
									color: statusColorHexCode,
								}}
							>
								<p className="text-lg">&#x2022;</p>
								<p className="orderStatusDescription">
									{params.value}
								</p>
							</div>
							{params.data.driverName !== " " && (
								<p className="w-full flex items-center gap-1">
									<DriverIcon />
									<span className="font-normal">
										{params.data.driverName}
									</span>
								</p>
							)}
						</div>
					);
				},
				suppressSizeToFit: isSmallScreen,
			},
			{
				field: "createdAt",
				headerName: strings?.registereddate,
				valueFormatter: (params) => valueDateFormatter(params?.value),
				width: 140,
			},
			{
				headerName: strings?.seller,
				cellRendererFramework: (params: any) => {
					const sellerUserName = params.data.sellerUserName;
					const sellerNumber = params.data.businessNr;
					const sellerUniqueId = params.data.uniqueSellerIdentifier;
					const sellerString: string =
						sellerUserName + " (" + sellerUniqueId + ") ";
					return (
						<div className="buyerField">
							<p className="text-[#2C2C2C] font-semibold">
								{sellerString}
							</p>
							<p className="text-[#4F16C2] font-normal">
								{sellerNumber}
							</p>
						</div>
					);
				},
				hide:
					userRoleId === userRoles.CLIENT ||
					userRoleId === userRoles.SUBCLIENT ||
					!hasAccessToSellers,
				suppressSizeToFit: isSmallScreen,
			},
			{
				field: "buyerNameAndSurname",
				headerName: strings?.buyer,
				width: 160,
				cellRendererFramework: (params: any) => {
					const buyerNameSurname = params.data.buyerNameAndSurname;
					const phone = params.data.buyerPhoneNo;
					return (
						<div className="buyerField">
							<p className="text-[#2C2C2C] font-semibold">
								{buyerNameSurname}
							</p>
							<p className="text-[#4F16C2] font-normal">
								{phone}
							</p>
						</div>
					);
				},
				suppressSizeToFit: isSmallScreen,
			},
			{
				field: "buyerPhoneNo",
				headerName: "Telefoni i beresit",
				hide: true,
			},
			{
				field: "orderDescription",
				headerName: strings?.description,
				width: 180,
				suppressSizeToFit: isSmallScreen,
				hide: true,
			},
			{
				field: "packageDescription",
				headerName: strings?.packageDescription,
			},
			{
				field: "country",
				headerName: strings?.country,
				width: 120,
				suppressSizeToFit: isSmallScreen,
			},
			{
				field: "city",
				headerName: strings?.city,
				width: 120,
				suppressSizeToFit: isSmallScreen,
			},
			{
				field: "orderPrice",
				valueGetter: (params: any) => {
					return params.data.orderPrice
						? `${currencySymbol(params.data.currencyId)} ${
								params.data.orderPrice
						  }`
						: "- " + currencySymbol(params.data.currencyId);
				},
				width: 130,
				headerName: strings?.packageValueWithVAT,
				suppressSizeToFit: isSmallScreen,
			},
			{
				field: "transportPrice",
				headerName: strings?.transportPrice,
				valueGetter: (params: any) => {
					return params.data.transportPrice
						? `${currencySymbol(params.data.currencyId)} ${
								params.data.transportPrice
						  }`
						: "- " + currencySymbol(params.data.currencyId);
				},
				width: 130,
				hide: !accessToOrderTransportPrice,
				suppressSizeToFit: isSmallScreen,
			},
			{
				field: "modal",
				headerName: " ",
				width: 130,
				cellRenderer: (params: any) => {
					return (
						<Button size="large" style={{ color: "green" }}>
							{strings?.open}
						</Button>
					);
				},
				suppressSizeToFit: isSmallScreen,
			},
			{
				field: "redirect",
				headerName: strings?.redirect,
				width: 150,
				cellRenderer: (params: any) => {
					if (
						((params?.data?.statusId ===
							orderStatuses.RETURN_STORAGE &&
							params?.data?.statusDescription !== null) ||
							(params?.data.internationalStatusId ===
								orderStatuses.RETURN_STORAGE &&
								params?.data?.statusDescription !== null)) &&
						(userRoleId === userRoles.CLIENT ||
							userRoleId === userRoles.SUBCLIENT)
					) {
						return (
							<Button size="large" style={{ color: "green" }}>
								{strings?.redirect}
							</Button>
						);
					} else {
						return "-";
					}
				},
				hide:
					userRoleId !== userRoles.CLIENT &&
					userRoleId !== userRoles.SUBCLIENT,
				suppressSizeToFit: isSmallScreen,
			},
			{
				field: "transportPrice",
				headerName: "Kosto e transportit",
				cellRenderer: (params: any) =>
					params.data.transportPrice
						? `${currencySymbol(params.data.currencyId)} ${
								params.data.transportPrice
						  }`
						: "-",
				hide: true,
			},

			{
				field: "deliveryInstructions",
				headerName: "Instrukcione",
				hide: true,
			},

			{
				field: "pickedUpDate",
				headerName: "Data e pranimit",
				valueFormatter: (params) => valueDateFormatter(params?.value),
				hide: true,
			},
			{
				field: "driverName",
				headerName: "Pergjegjesi",
				hide: true,
			},
			{
				field: "currencyId",
				headerName:
					strings?.registeredCurrency ?? "Monedha e regjistrimit",
				valueGetter: (params: any) =>
					currencySymbol(params.data?.currencyId),
				width: 140,
				// Shown on PostmanAL, hidden elsewhere. Was `hide: true` unconditionally, so the
				// columns never appeared at all; DriverDetails already gates on the flag.
				hide: !dualCurrencyEnabled,
			},
			{
				field: "deliveredCurrencyId",
				headerName: strings?.collectedCurrency ?? "Monedha e arketuar",
				valueGetter: (params: any) =>
					currencySymbol(params.data?.deliveredCurrencyId),
				width: 140,
				hide: !dualCurrencyEnabled,
			},
			{
				field: "refusedPrice",
				headerName: "Tarifa e refuzimit",
				valueGetter: (params: any) => {
					return params.data.refusedPrice
						? `${currencySymbol(params.data.currencyId)} ${
								params.data.refusedPrice
						  }`
						: "-" + currencySymbol(params.data.currencyId);
				},
				hide: true,
			},
			{
				field: "weight",
				headerName: "Pesha ~ KG",
				hide: true,
			},

			{
				field: "exchangeable",
				headerName: "Ndërrim",
				valueGetter: (params) => {
					return params.data.exchangeable ? "PO" : "JO";
				},
				hide: true,
			},
			{
				field: "statusChangeComment",
				headerName: "Komenti i fundit",
				hide: true,
			},
			{
				field: "settlementId",
				headerName: "Nr. Barazimit",
				valueGetter: (params) => {
					return params.data.settlementId
						? params.data.settlementId
						: "N/A";
				},
				hide: true,
			},
			{
				field: "gatheringCity",
				headerName: "Qyteti i Mbledhjes",
				hide: true,
			},
			{
				field: "sellerNameAndSurname",
				headerName: strings?.seller,
				cellRendererFramework: (params: any) => {
					const sellerUserName = params.data.sellerUserName;
					const sellerNumber = params.data.businessNr;
					const sellerUniqueId = params.data.uniqueSellerIdentifier;
					const sellerString: string =
						sellerUserName + " (" + sellerUniqueId + ") ";
					return <div className="buyerField"></div>;
				},
				hide: true,
			},
			{
				field: "sellerUserName",
				headerName: "Username",
				hide: true,
			},
			{
				field: "sellerPhoneNo",
				headerName: "Telefoni i shitësit",
				hide: true,
			},
			{
				field: "costumsCode",
				headerName: "Kodi doganor",
				valueGetter: (params: any) => {
					return params.value ? params.value : "N/A";
				},
				hide: true,
			},
			{
				field: "customsDescription",
				headerName: "Pershkrimi",
				valueGetter: (params: any) => {
					return params.data.customsDescription
						? params.data.customsDescription
						: "N/A";
				},
				hide: true,
			},
			{
				field: "origjina",
				headerName: "Origjina",
				valueGetter: (params: any) => {
					return params.data.origjina ? params.value : "N/A";
				},
				hide: true,
			},
			{
				field: "garancion",
				headerName: "Garancion",
				valueGetter: (params: any) => {
					return params.data.garancion ? "PO" : "JO";
				},
				hide: true,
			},
			{
				headerName: "Adresa e bleresit",
				field: "buyerAddress",
				hide: true,
			},
			{
				field: "openable",
				headerName: "Mund te hapet",
				valueGetter: (params: any) => {
					return params.data.openable ? "PO" : "JO";
				},
				hide: true,
			},
			{
				field: "fragile",
				headerName: "E thyeshme",
				valueGetter: (params) => {
					return params.data.fragile ? "PO" : "JO";
				},
				hide: true,
			},
			{
				field: "changes",
				headerName: "Ka ndryshime",
				valueGetter: (params) => {
					return params.data.changes ? "PO" : "JO";
				},
				hide: true,
			},
			{
				field: "transportingTime",
				headerName: "Koha ne transport",
				hide: true,
			},
			{
				field: "vat",
				headerName: "TVSH-ja",
				valueGetter: (params) => {
					return params.data.vat
						? `${currencySymbol(params.data.currencyId)} ${
								params.data.vat
						  }`
						: "-" + currencySymbol(params.data.currencyId);
				},
				hide: true,
			},
			{
				field: "orderPriceNoVat",
				headerName: "Vlera paTVSH",
				valueGetter: (params) => {
					return params.data.orderPriceNoVat
						? `${currencySymbol(params.data.currencyId)} ${
								params.data.orderPriceNoVat
						  }`
						: "-" + currencySymbol(params.data.currencyId);
				},
				hide: true,
			},
			{
				field: "latestStatusDate",
				valueFormatter: (params) => valueDateFormatter(params?.value),
				headerName: "Data e mbylljes",
				hide: true,
			},
			{
				field: "ditetNeTransport",
				headerName: "Ditet ne transport",
				hide: true,
			},
			{
				field: "oretNeTransport",
				headerName: "Oret ne transport",
				hide: true,
			},
			{
				field: "costumsCode",
				headerName: "Kodi doganor",
				hide: true,
			},
			{
				field: "transportingDate",
				headerName: "Data transportit",
				hide: true,
			},
			{
				field: "deliveredDate",
				headerName: "Data dorezimit",
				hide: true,
			},
		]);
		// dualCurrencyEnabled starts false and flips once GET Currency/list resolves; without
		// it here the two currency columns would stay hidden on PostmanAL.
	}, [strings, dualCurrencyEnabled]);

	const setCountriesAndCities = (zones: any, data: any) => {
		if (zones) {
			let countries = [];
			console.log(data);
			if (data?.internationalStatusId === orderStatuses.RETURN_STORAGE) {
				countries = zones
					.filter(
						(zone: any) =>
							zone.levelId === 1 && zone.id === data.countryId
					)
					.map((item: any) => ({
						value: item.id,
						label: item.description,
					}));
			} else {
				countries = zones
					.filter((item: any) => item.levelId === 1)
					.map((item: any) => ({
						value: item.id,
						label: item.description,
					}));
			}
			setCountryDropDown(countries);
			const filteredCities = zones
				.filter((item: any) => item.levelId === 2)
				.map((item: any) => ({
					value: item.id,
					label: item.description,
				}));
			setCityDropDown(filteredCities);
			const cities = zones?.filter((item: any) => item.levelId === 2);
			setCities(cities);
		}
	};

	const onCellClicked = async (params: any) => {
		const colId = params.column.colId;
		switch (colId) {
			case "displayId":
				await onOrderIdClicked(params?.data);
				break;
			case "redirect":
				await redirectClick(params?.data);
				break;
			case "modal":
				await openSmallDetailModal(params?.data);
				break;
			case "sellerNameAndSurname":
				await navigateToClientDetails(params?.data?.sellerId);
				break;
		}
	};

	const openSmallDetailModal = (data: any) => {
		fetchOrderHistory(data?.id);
		setRowData(data);
		setOrderDetailsModalOpen(true);
	};

	const onOrderIdClicked = (data: any) => {
		const orderId = data?.id?.toString();
		// navigate("/order-details", { state: orderId });
		const url = `/order-details?id=${orderId}`;
		window.open(url, "_blank");
	};

	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(20);
	const [total, setTotal] = useState(0);
	const onPageChanged = (page: number, pageSize: number) => {
		setCurrentPage(page);
		getOrders(
			pageSize,
			page,
			filterData?.countryIds,
			filterData?.cityIds,
			filterData?.statusIds,
			filterData?.displayIds,
			filterData?.orderDescription,
			filterData?.fromDate,
			filterData?.toDate,
			filterData?.filterType,
			filterData?.orderTypeFilter,
			filterData?.sellerIds,
			filterData?.staffIds,
			filterData?.selectedSettled
		);
	};
	const handlePageSizeChange = async (current: number, size: number) => {
		setPageSize(size);
	};

	const startOrderIndex = (currentPage - 1) * pageSize + 1;
	const endOrderIndex =
		startOrderIndex + Math.min(pageSize, total - startOrderIndex);

	const customIcon = new Icon({
		iconUrl: require("../../assets/pin.png"),
		iconSize: [38, 38],
	});

	const [redirectedOrderData, setRedirectedOrderData] = useState<any>();

	const redirectClick = useCallback(
		async (data: any) => {
			if (
				// isClient &&
				data?.statusId === orderStatuses.RETURN_STORAGE ||
				data?.internationalStatusId === orderStatuses.RETURN_STORAGE
			) {
				const zones = await fetchZonesCached();
				// if(data.originCountryId )
				if (zones) {
					setCountriesAndCities(zones, data);
				}
				setRedirectedOrderData(data);
				if (mapCenter === null) {
					setMapCenter([42.6026, 20.903]);
					setLatitude(42.6026);
					setLongitude(20.903);
					const position = getValidCoordinates(latitude, longitude);
					setPosition(position);
				}
				setLoading(false);
				setOrderRedirectModalOpen(true);
			}
		},
		[mapCenter, latitude, longitude]
	);
	const onNewOrderPriceForReturnChange = (event: any) => {
		setNewOrderPriceForReturn(event.target.value);
	};
	const onCountrySelect = (e: any) => {
		const filteredCities = cities
			.filter((item: any) => item.parentId === e)
			.map((item: any) => ({
				value: item.id,
				label: item.description,
			}));
		setCityDropDown(filteredCities);
		setCountry(e);
		setAddress("");
		setCity("");
		//(autocompleteRef as any).current.handleClear();
		if (e === 1) {
			setMapCenter([42.6026, 20.903]);
			setPosition(null);
			setCountryLabel("xk");
		} else if (e === 2) {
			setMapCenter([41.1533, 20.1683]);
			setPosition(null);
			setCountryLabel("al");
		} else if (e === 3) {
			setMapCenter([41.6086, 21.7453]);
			setPosition(null);
			setCountryLabel("mk");
		}
	};

	const handleCityChange = (value: any) => {
		if (value?.value) {
			const id = value.value;
			setCity(id);
			setCityLabel(value?.label);
			setAddress("");
		} else {
			setCity("");
			setAddress("");
		}
	};

	const handleChange = (address: any) => {
		const selectedLocation = address;
		if (selectedLocation) {
			const lat = selectedLocation.lat;
			const lng = selectedLocation.lng;
			setAddressPosition([lat, lng]);
			setPosition([lat, lng]);
			setApiLatitude(lat);
			setApiLongitude(lng);
			fetchGeoData(lat, lng);
			setAddress(selectedLocation.label ?? "");
		}
	};

	const getValidCoordinates = (
		lat: number | null,
		lng: number | null
	): LatLngExpression | null => {
		if (lat !== null && lng !== null) {
			return [lat, lng];
		}
		return null;
	};

	const eventHandlers = useMemo(
		() => ({
			dragend() {
				const marker = markerRef.current;
				if (marker != null) {
					const latLng = marker["_latlng"];
					setPosition(latLng);
					setApiLatitude(latLng["lat"]);
					setApiLongitude(latLng["lng"]);
					fetchGeoData(latLng["lat"], latLng["lng"]);
				}
			},
		}),
		[]
	);
	const ResetCenterView = (props: any) => {
		const { selectedPosition } = props;
		const { addressPosition } = props;
		const map = useMap();
		useEffect(() => {
			if (selectedPosition === 1) {
				map.setView(L.latLng(42.6026, 20.903), map.getZoom(), {
					animate: true,
				});
			} else if (selectedPosition === 2) {
				map.setView(L.latLng(41.1533, 20.1683), map.getZoom(), {
					animate: true,
				});
			} else if (selectedPosition === 3) {
				map.setView(L.latLng(41.6086, 21.7453), map.getZoom(), {
					animate: true,
				});
			}
			if (addressPosition) {
				map.setView(L.latLng(addressPosition), 15, {
					animate: true,
				});
			}
		}, [addressPosition, map, selectedPosition]);
		useEffect(() => {
			map.invalidateSize();
		}, [map]);

		return null;
	};

	const validateBuyerData = (data: any) => {
		const { firstName, lastName, sectionId, address, phone, orderPrice } =
			data;
		if (!firstName) {
			toast.error("Emri duhet te plotesohet.");
			return false;
		}
		if (!lastName) {
			toast.error("Mbiemri duhet te plotesohet.");
			return false;
		}
		if (!address) {
			toast.error("Adresa duhet te plotesohet.");
			return false;
		}
		if (!phone) {
			toast.error("Nr i telefonit duhet te plotesohet.");
			return false;
		}
		if (!sectionId) {
			toast.error(
				"This Zone is not registered yet, contact support please!"
			);
			return false;
		}
		if (!orderPrice) {
			toast.error("Vlera e pakos duhet te plotesohet!");
			return false;
		}

		return true;
	};

	const orderRedirect = async () => {
		const buyer = {
			id: redirectedOrderData?.id,
			firstName: name,
			lastName: lastName,
			phone: phone,
			address: address,
			sectionId: sectionId,
			latitude: apiLatitude?.toString() || null,
			longitude: apiLongitude?.toString() || null,
			countryId: country,
			// Lets the API keep the section inside this city if the geofence placed it elsewhere.
			// Left out when unset: the API reads JSON strictly, and "" is not a number.
			cityId: city ? Number(city) : undefined,
			customsId: customsId,
			orderPrice: orderPrice ?? redirectedOrderData?.orderPrice,
		};
		if (validateBuyerData(buyer)) {
			try {
				setIsSubmitting(true);
				const response = await api.post("Order/order-redirect", buyer);
				if (response.status === 200) {
					toast.success("Porosia u rinis me sukses!");
					await fetchTableData();
					setOrderRedirectModalOpen(false);
					closeRedirectModal();
					return;
				}
			} catch (error) {
				console.log(error);
			} finally {
				setIsSubmitting(false);
			}
		} else {
			return;
		}
	};
	const closeRedirectModal = () => {
		setName("");
		setLastName("");
		setAddress("");
		setPhone("");
		setCountry(null);
		setLoading(true);
		setOrderRedirectModalOpen(false);
		setAddress("");
		setCustomsId(null);
		setOrderPrice(0);
		setCity(undefined);
		//(autocompleteRef as any).current.handleClear();
	};

	const closeDetailsModal = () => {
		setOpenOrderHistory(false);
		setOrderDetailsModalOpen(false);
	};
	const onCloseChangeOrderPrice = () => {
		setChangeOrderPriceOpen(false);
	};

	const exportOrderDetailsToExcel = async (
		orderIds: any[] | undefined,
		pageSize: number,
		currentPage: number,
		countryIds?: any[],
		cityIds?: any[],
		statusIds?: any[],
		displayId?: any,
		orderDescription?: any,
		fromDate?: any,
		toDate?: any,
		filterType?: any,
		orderTypeFilter?: any,
		sellerIds?: any[],
		staffIds?: any[],
		selectedSettled?: boolean,
		paginationDisabled?: boolean,
		isSettledOrders?: boolean
	) => {
		try {
			const displayIdSearchTerm = displayId || null;
			if (!Array.isArray(orderIds)) {
				throw new Error("orderIds must be an array");
			}

			const fileName = `${
				new Date().toISOString().split("T")[0]
			}-${Math.floor(Math.random() * 10000)}.xlsx`;

			const response = await api.post(
				"Order/get-order-details-excel",
				{
					OrderIds: orderIds,
					PageSize: pageSize,
					CurrentPage: currentPage,
					CountryIds:
						countryIds?.map((c) => ({
							Id: getValueFromOption(c),
						})) || [],
					CityIds:
						cityIds?.map((c) => ({ Id: getValueFromOption(c) })) ||
						[],
					StatusIds:
						statusIds?.map((c) => ({
							Id: getValueFromOption(c),
						})) || [],
					DisplayId: displayId,
					OrderDescription: orderDescription,
					FromDate: fromDate,
					ToDate: toDate,
					FilterType: filterType,
					OrderTypeFilter: orderTypeFilter || null,
					SellerIds:
						sellerIds?.map((c) => ({
							Id: getValueFromOption(c),
						})) || [],
					StaffIds:
						staffIds?.map((c) => ({ Id: getValueFromOption(c) })) ||
						[],
					Settled: selectedSettled,
					PaginationDisabled: paginationDisabled,
					DisplayIdSearchTerm: displayIdSearchTerm,
					IsSettledOrders: isSettledOrders,
				},
				{
					headers: {
						"Content-Type": "application/json",
					},
					responseType: "blob",
				}
			);

			const blob = new Blob([response.data], {
				type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
			});
			const fileURL = window.URL.createObjectURL(blob);
			const link = document.createElement("a");
			link.href = fileURL;
			link.setAttribute("download", fileName);
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);

			toast.success("Excel exported successfully!");
		} catch (error) {
			console.error("Error exporting Excel file:", error);
			toast.error("Failed to export to Excel.");
		}
	};

	const onExportSelectedId = async () => {
		const selectedRows = grid.current?.api?.getSelectedRows();
		const orderIds: any[] | undefined = selectedRows?.map((row: any) => ({
			id: row.id,
		}));

		await exportOrderDetailsToExcel(
			orderIds,
			total,
			1,
			filterData?.countryIds,
			filterData?.cityIds,
			filterData?.statusIds,
			filterData?.displayId,
			filterData?.orderDescription,
			filterData?.fromDate,
			filterData?.toDate,
			filterData?.filterType,
			filterData?.orderTypeFilter,
			filterData?.sellerIds,
			filterData?.staffIds,
			filterData?.selectedSettled,
			true,
			false
		);
	};

	const getClientCompanyFinance = async () => {
		try {
			const response = await api.get("Finance/client-finance");
			if (response) {
				const result = response.data[0];
				return result;
			}
		} catch (error) {
			console.log(error);
		}
	};

	const validateOrderPriceChange = async (
		orderPriceParam: number
	): Promise<boolean> => {
		const clientBalanceInPostman = await getClientCompanyFinance();
		const clientCurrentBalance =
			clientBalanceInPostman?.currentBalance - rowData.transportPrice;
		if (clientCurrentBalance <= 0) {
			return false;
		}
		if (clientCurrentBalance < /*rowData?.orderPrice*/ orderPriceParam) {
			return false;
		}
		return true;
	};

	const onReturnOrderClick = () => {
		setNewOrderPriceForReturn(0);
		setChangeOrderPriceOpen(true);
	};

	const [isChangingOrderPrice, setIsChangingOrderPrice] = useState(false);

	const onChangeOrderPriceClick = async () => {
		setIsChangingOrderPrice(true);

		const orderPrice: number =
			newOrderPriceForReturn > 0
				? newOrderPriceForReturn
				: rowData?.orderPrice;
		if (orderPrice <= 0) {
			toast.error("Kjo porosi ka vlere negative, nuk lejohet per kthim");
			return;
		}

		if (!rowData?.canBeReturned) {
			toast.error("Kthimi i porosise nuk lejohet");
			return;
		}
		const validOrderPrice: boolean =
			await validateOrderPriceChange(orderPrice);
		if (!validOrderPrice) {
			toast.error(
				"Nuk keni balanc te mjaftueshem per te krijuar kthim te porosise"
			);
			return;
		}
		try {
			const response = await api.post("Order/insert-return-order", null, {
				params: { orderId: rowData?.id, orderPrice },
			});
			if (response.status === 200) {
				toast.success("Sukses!");
				await fetchTableData();
				setOrderDetailsModalOpen(false);
				setChangeOrderPriceOpen(false);
				setNewOrderPriceForReturn(0);
				return;
			}
		} catch (error) {
			console.log(error);
			toast.error("Error: " + error);
		} finally {
			setIsChangingOrderPrice(false);
		}
	};

	const onSelectionChanged = () => {
		const selectedNodes = grid.current?.api.getSelectedNodes();
		const selectedOrders =
			selectedNodes?.map((node) => ({
				id: node.data.id,
				status: node.data.statusDescription,
				name: node.data.buyerNameAndSurname,
				phone: node.data.buyerPhoneNo,
				city: node.data.city,
				packagePrice: node.data.orderPrice,
				statusColor: node.data.statusColorHexCode,
			})) || [];
		setSelectedOrderIds(selectedOrders);
	};
	const transportPriceHandler = () => {
		const selectedRows = grid.current?.api.getSelectedRows();
		const selectedOrders = selectedRows
			?.filter(
				(item: any) => item.completed === 1 || item.settlementStatus > 0
			)
			.map((item: any) => item.displayId)
			.toLocaleString();
		const ordersAreSettled = selectedRows?.some(
			(item: any) => item.completed === 1 || item.settlementStatus > 0
		);
		if (ordersAreSettled && selectedRows) {
			toast.error(
				`Porosia ${selectedOrders} eshte e perfshire ne barazim. Nuk mund te ndryshoni cmimin e transportit.`
			);
			return false;
		} else if (selectedRows && !ordersAreSettled) {
			setModalTransportPrice(true);
		}
	};

	const updateTransportPriceHandler = async () => {
		try {
			const orders = selectedOrderIds?.map((orderId) => ({
				OrderId: orderId.id,
				TransportPrice: transportCost,
			}));

			const response = await api.post(
				"/order/update-transport-price",
				orders
			);

			toast.success("Kosto e transportit u ndryshua me sukses");

			setModalTransportPrice(false);
		} catch (error) {
			console.error("Error updating transport price:", error);
		}
	};

	const customOptions = [
		{
			label: strings?.labels?.print_ticket,
			value: "print_ticket",
		},
		{
			label: strings?.labels?.print_list,
			value: "print_list",
		},
		{
			label: strings?.labels?.harley_ticket,
			value: "harley_ticket",
			show: userRoleId !== userRoles.CLIENT && hasAccessToHarleyTickets,
		},
		{
			label: strings?.labels?.export_excel,
			value: "export_excel",
		},
		{
			label: strings?.labels?.changeTransportPrice,
			value: "changeTransportPrice",
			show: canChangeOrderValue,
		},
		{
			label: strings?.labels?.ready,
			value: "ready",
			show: userRoleId === userRoles.CLIENT,
		},
		{
			label: strings?.labels?.register_status,
			value: "register_status",
			show: userRoleId === userRoles.CLIENT,
		},
		{
			label: "Ndrysho Statusin",
			value: "statusChange",
			show: hasBulkOrderStatusPermission,
		},
		{
			label: "Fshi Porosite",
			value: "deleteOrders",
			show: userRoleId === userRoles.ADMIN,
		},
	];

	const hasSelectedOrders = selectedOrderIds.length > 0;

	const printTickets = async (format: string) => {
		const ids = (grid.current as any).api
			.getSelectedRows()
			?.map((item: any) => ({
				id: item.displayId,
			}));

		if (!ids?.length) {
			toast.warning("Selekto porosite per te printuar");
			return true;
		}
		const params =
			format === "A4"
				? { formatA4: true }
				: format === "harleyTicket"
				? { harleyTicket: true }
				: {};
		try {
			const response = await api.post("Order/print-order-ticket", ids, {
				params,
				responseType: "blob",
			});
			const file = response.data;
			const fileUrl = window.URL.createObjectURL(file);

			const pdfWindow = window.open();
			if (pdfWindow) {
				pdfWindow.location.href = fileUrl;
			} else {
				toast.error(
					"Popup eshte i bllokuar. Ju lutemi lejoni popup-ët për këtë faqe."
				);
			}
		} catch (error) {
			console.log(error);
		}
	};

	const printOrderList = async () => {
		const ids = grid?.current?.api.getSelectedRows()?.map((item: any) => {
			return { id: item.id };
		});

		if (!ids || ids.length === 0) {
			toast.warning("No orders selected for printing");
			return;
		}

		try {
			const response = await api.post("Order/order-list-details", ids, {
				responseType: "blob",
			});

			const file = response.data;
			const fileUrl = window.URL.createObjectURL(file);

			const pdfWindow = window.open();
			if (pdfWindow) {
				pdfWindow.location.href = fileUrl;
			} else {
				toast.error(
					"Popup is blocked. Please allow pop-ups for this page."
				);
			}
		} catch (error) {
			console.error("Error exporting order list details:", error);
		}
	};

	const printHarleyTickets = async () => {
		const ids = (grid.current as any).api
			.getSelectedRows()
			?.map((item: any) => ({
				id: item.id?.toString(),
			}))
			.filter((item: any) => item.id);

		if (!ids?.length) {
			toast.warning("Selekto porosite per te printuar");
			return true;
		}
		try {
			const response = await api.post("Order/print-harley-ticket", ids, {
				responseType: "blob",
			});
			const file = response.data;
			const fileUrl = window.URL.createObjectURL(file);

			const pdfWindow = window.open();
			if (pdfWindow) {
				pdfWindow.location.href = fileUrl;
			} else {
				toast.error(
					"Popup eshte i bllokuar. Ju lutemi lejoni popup-ët për këtë faqe."
				);
			}
		} catch (error) {
			console.log(error);
		}
	};

	const [
		selectedOrdersForBulkStatusChange,
		setSelectedOrdersForBulkStatusChange,
	] = useState<any>([]);

	const openModalForStatusChange = async () => {
		const selectedRows = (grid.current as any)?.api?.getSelectedRows();
		if (selectedRows.length <= 0) {
			toast.error(
				"Ju lutem selektoni porosite per te cilave deshironi te ndryshoni statusin"
			);
			return;
		} else {
			setSelectedOrdersForBulkStatusChange(selectedRows);
			// The window builds its user dropdown from this list as soon as a status is picked.
			await loadAllUsers();
			setIsBulkStatusChangeModalVisible(true);
		}
	};

	const handleSaveBulkChangeOrderStatus = async (selectedData: any) => {
		try {
			const response = await api.post(
				"Order/orderstatuschange-bulk",
				selectedData
			);
			if (response.status === 200) {
				fetchTableData();
				closeStatusChangeModal();
				toast.success("Statusi u ndryshua me sukses");
				return;
			}
		} catch (error) {
			console.log(error);
		}
		return;
	};

	const closeStatusChangeModal = () => {
		setIsBulkStatusChangeModalVisible(false);
		setSelectedOrdersForBulkStatusChange((prevState: any) => []);
		(grid.current as any)?.api?.deselectAll();
	};

	const handleClientStatusChangeToWaitingPickup = async () => {
		if (waitingPickupOrderList && waitingPickupOrderList.length > 0) {
			try {
				const response = await api.post(
					"Order/clientorderstatusupdate",
					waitingPickupOrderList
				);

				if (response.status === 200) {
					toast.success("Statusi u ndryshua me sukses!");
					setWaitingPickupOrderList([]);
					fetchTableData();
					setIsWaitingForPickupModalOpen(false);
				} else {
					toast.error("Ndryshimi i statusit deshtoj!");
				}
			} catch (error) {
				console.error(
					"An error occurred while making the API request:",
					error
				);
				toast.error(
					"Një gabim ndodhi. Ju lutemi provoni përsëri më vonë"
				);
			}
		}
	};

	const orderStatusChangeToWatingForPickup = async () => {
		const selectedRows = grid.current?.api?.getSelectedRows();
		if (selectedRows && selectedRows.length > 0) {
			const checkStatusId = selectedRows.some(
				(item: any) => item.statusId !== orderStatuses.REGISTERED
			);
			if (checkStatusId) {
				toast.error(
					"Ju lutem filtroni dhe selektoni vetem porosite te cilat kane statusin Regjistruara"
				);
				return;
			} else {
				const orderList = selectedRows.map((order) => ({
					orderId: order.id,
				}));
				setWaitingPickupOrderList(orderList);
				setIsWaitingForPickupModalOpen(true);
			}
		} else {
			toast.error(
				"Ju lutem selektoni porosite qe deshironi te i vendosni ne Gati per Grumbullim"
			);
		}
	};

	const orderStatusChangeToPreviousStatus = async () => {
		try {
			const response = await api.post(
				"Order/change-to-previous-status",
				waitingPickupOrderList
			);
			if (response.status === 200) {
				await fetchTableData();
				setWaitingPickupOrderList([]);
				setOpenChangeStatusToPreviousModal(false);
				toast.success("Statusi u ndryshua me sukses");
			}
		} catch (error) {
			console.log(error);
		}
	};

	const orderStatusChangeToRegisterStatus = async () => {
		const selectedRows = grid.current?.api?.getSelectedRows();
		if (selectedRows && selectedRows.length > 0) {
			const checkStatusId = selectedRows.some(
				(item: any) => item.statusId !== orderStatuses.WAITING_PICKUP
			);
			if (checkStatusId) {
				toast.error(
					"Ju lutem filtroni dhe selektoni vetem porosite te cilat kane statusin Gati per Grumbullim"
				);
				return;
			} else {
				const orderList = selectedRows.map((order: any) => ({
					id: order.id.toString(),
				}));
				setWaitingPickupOrderList(orderList);
				setOpenChangeStatusToPreviousModal(true);
			}
		}
	};

	const [
		openDeleteOrdersConfirmationModal,
		setOpenDeleteOrdersConfirmationModal,
	] = useState<boolean>(false);

	const openDeleteModal = () => {
		const selectedRows = grid.current?.api?.getSelectedRows();
		if (selectedRows && selectedRows.length > 0) {
			const checkStatusId = selectedRows.some(
				(item: any) =>
					item.statusId !== orderStatuses.REGISTERED &&
					item.statusId !== orderStatuses.WAITING_PICKUP
			);
			if (checkStatusId) {
				toast.error(
					"Ju lutem filtroni vetem porosite te cilat kane statusin Regjistruar dhe Gati per Grumbullim"
				);
				return;
			} else {
				setOpenDeleteOrdersConfirmationModal(true);
			}
		} else {
			toast.error(
				"Ju lutem selektoni porosite qe deshironi te i fshini nga sistemi!"
			);
		}
	};

	const deleteSelectedOrders = async () => {
		const selectedRows = grid.current?.api?.getSelectedRows();
		if (selectedRows && selectedRows.length > 0) {
			const checkStatusId = selectedRows.some(
				(item: any) =>
					item.statusId !== orderStatuses.REGISTERED &&
					item.statusId !== orderStatuses.WAITING_PICKUP
			);
			if (checkStatusId) {
				toast.error(
					"Ju lutem filtroni vetem porosite te cilat kane statusin Regjistruar dhe Gati per Grumbullim"
				);
				return;
			} else {
				const data = selectedRows.map((item: any) => ({
					orderId: item.id,
					uuid: item.uuid,
					countryId: item.countryId,
				}));
				try {
					const response = await api.post(
						"Order/delete-registered-waitingPickup-orders",
						data
					);
					if (response.status === 200) {
						fetchTableData();
						setOpenDeleteOrdersConfirmationModal(false);
						toast.error("Porosite u fshine me sukses!");
					}
				} catch (error) {
					console.log(error);
				}
			}
		} else {
			toast.error(
				"Ju lutem selektoni porosite qe deshironi te i fshini nga sistemi!"
			);
			return;
		}
	};

	return (
		<>
			<div className="orderMainContainer">
				{/* <OrderStatus /> */}
				<div className="ordersContainer">
					<FilterSection
						title={strings?.allOrders}
						onFilterChange={onFilterOrders}
						selectedOptions={customOptions}
						onExportSelectedId={onExportSelectedId}
						transportPriceHandler={transportPriceHandler}
						showAdminFilters={!isClient}
						hasSelectedOrders={hasSelectedOrders}
						onPrintTickets={printTickets}
						onPrintList={printOrderList}
						onSelectedOrderStatusChange={
							orderStatusChangeToWatingForPickup
						}
						orderStatusChangeToRegisterStatus={
							orderStatusChangeToRegisterStatus
						}
						onStatusChange={openModalForStatusChange}
						selectedStatusOrder={statusFilters}
						onPrintHarleyTickets={printHarleyTickets}
						onOrderDelete={openDeleteModal}
					/>
					<div
						className="h-auto"
						style={{
							display: "flex",
							justifyContent: "flex-end",
							paddingRight: "3.7rem",
						}}
					>
						<Button
							onClick={handleFilterSubmit}
							disabled={filterButtonLoading}
							className="border-[#4F16C2] bg-[#4F16C2] text-white flex justify-center items-center"
							style={{ width: "100px" }}
						>
							{"Filtro"}
						</Button>
					</div>
					<div className="h-auto">
						<PaginationTable
							current={currentPage}
							pageSize={pageSize}
							total={total}
							startOrderIndex={startOrderIndex}
							endOrderIndex={endOrderIndex}
							onChange={onPageChanged}
							onShowSizeChange={handlePageSizeChange}
						/>
					</div>
					<div
						className="ag-theme-alpine"
						style={{
							width: "100%",
							height: "800px",
							// overflowX: "auto"
						}}
					>
						<AgGridReact
							rowData={tableData}
							columnDefs={tableColumns}
							defaultColDef={defaultColDef}
							undoRedoCellEditing={true}
							undoRedoCellEditingLimit={20}
							suppressCopyRowsToClipboard={true}
							defaultExcelExportParams={
								defaultExcelExportSettings
							}
							rowSelection="multiple"
							ref={grid}
							enableRangeSelection={true}
							cacheQuickFilter={true}
							// domLayout="autoHeight"
							onCellClicked={onCellClicked}
							suppressPaginationPanel={false}
							rowHeight={60}
							// onFirstDataRendered={onFirstDataRendered}
							onSelectionChanged={onSelectionChanged}
						/>
					</div>
				</div>
				<OrderStatusModal
					visible={isBulkStatusChangeModalVisible}
					onClose={closeStatusChangeModal}
					selectedOrders={selectedOrdersForBulkStatusChange}
					onSave={handleSaveBulkChangeOrderStatus}
					allUsers={allUsers ?? []}
					defaultSystemCountryId={defaultSystemCountryId}
				/>
			</div>
			<Modal
				open={orderRedirectModalOpen}
				width={1200}
				onCancel={closeRedirectModal}
				onOk={orderRedirect}
				title={strings?.restartOrder}
				cancelButtonProps={{
					loading: isSubmitting,
					disabled: isSubmitting,
				}}
				okButtonProps={{
					className: "bg-blue-500",
					loading: isSubmitting,
					disabled: isSubmitting,
				}}
			>
				<div className="openRedirectModalContainer">
					<div className="openRedirectModalInputs">
						<DefaultInput
							className="registerInput"
							label={strings?.name}
							placeholder={strings?.writename}
							value={name}
							onChange={(e: any) => setName(e.target.value)}
							allowClear={true}
						/>
						<DefaultInput
							className="registerInput"
							label={strings?.surname}
							placeholder={strings?.writesurname}
							value={lastName}
							onChange={(e: any) => setLastName(e.target.value)}
							allowClear={true}
						/>
						<DefaultSelect
							className="registerInput"
							label={strings?.country}
							flexDirection="col"
							alignCenter="start"
							placeholder={strings?.choose}
							options={countryDropDown}
							value={country}
							onChange={onCountrySelect}
							allowClear={true}
						/>
						<DefaultSelect
							className="registerInput"
							label={strings?.city}
							flexDirection="col"
							alignCenter="start"
							placeholder={strings?.choose}
							options={cityDropDown}
							value={city}
							onChange={handleCityChange}
							allowClear
							labelInValue={true}
						/>
						<div className="flex flex-col items-start gap-1">
							<label className="w-42">{strings?.address}</label>

							<AddressSelect
								onAddressChange={handleChange}
								country={countryLabel}
								selectedAddress={address}
								city={city}
							/>
						</div>
						<DefaultPhoneInput
							className="registerInputPhone"
							label={strings?.phone}
							placeholder="49 ..."
							initialPhoneNumber={phone}
							onPhoneNumberChange={(e) => setPhone(e)}
						/>

						<DefaultInput
							className="registerInput"
							label={
								strings?.packagePrice +
								currencySymbol(rowData?.currencyId)
							}
							placeholder={strings?.packagePrice}
							value={orderPrice}
							onChange={(e: any) => setOrderPrice(e.target.value)}
						/>
						{country &&
							country?.toString() !== defaultSystemCountryId && (
								<DefaultSelect
									placeholder={strings?.chooseidentification}
									className="registerInput"
									// Searched on the server, same codes and rules as the order form.
									options={customs.options}
									filterOption={customs.filterOption}
									onSearch={customs.onSearch}
									onPopupScroll={customs.onPopupScroll}
									onDropdownVisibleChange={
										customs.onDropdownVisibleChange
									}
									label={strings?.customsCode}
									flexDirection="col"
									alignCenter="start"
									value={customsId}
									onSelect={customs.select}
									onChange={(e) => {
										setCustomsId(e);
									}}
								/>
							)}
					</div>
					<div className="">
						<div>
							{!loading && mapCenter !== null && (
								<MapContainer
									center={mapCenter}
									zoom={7.5}
									scrollWheelZoom={false}
									style={{
										width: 430,
										height: 450,
										borderRadius: 20,
									}}
								>
									<TileLayer
										attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
										url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
									/>
									{position !== null && (
										<>
											<Marker
												draggable={true}
												position={position}
												icon={customIcon}
												eventHandlers={eventHandlers}
												ref={markerRef}
											>
												<Popup
													minWidth={90}
												>{`Position${position}`}</Popup>
											</Marker>
										</>
									)}
									<ResetCenterView
										selectedPosition={country}
										addressPosition={adressPosition}
									/>
								</MapContainer>
							)}
						</div>
						{(!latitude || !longitude) && (
							<p>{error || "Fetching location..."}</p>
						)}
					</div>
				</div>
			</Modal>
			<Modal
				open={orderDetailsModalOpen}
				onCancel={closeDetailsModal}
				title={strings?.orderDetails}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
			>
				<Divider />
				<div className="flex flex-col rounded-lg border-2 border-slate-100">
					<OrderDetailRow
						label={strings?.labels?.registration_date}
						value={rowData?.createdAt}
						style={style.oddRow}
						className="driverDetailRow"
					/>
					<OrderDetailRow
						label={strings?.status}
						value={rowData?.statusDescription}
						className="driverDetailRow"
					/>
					<OrderDetailRow
						label={strings?.packagePrice}
						value={formatMoney(
							rowData?.orderPrice,
							rowData?.currencyId
						)}
						className="driverDetailRow"
					/>
					<OrderDetailRow
						label={strings?.seller}
						style={style.oddRow}
						value={`${rowData?.sellerNameAndSurname}, ${rowData?.sellerCity},${rowData?.sellerCountry}, ${rowData?.sellerPhoneNo} `}
						className="driverDetailRow"
					/>
					<OrderDetailRow
						label={strings?.buyer}
						value={`${rowData?.buyerNameAndSurname}, ${rowData?.buyerAddress}, ${rowData?.city}, ${rowData?.country}, ${rowData?.buyerPhoneNo} `}
						className="driverDetailRow"
					/>
				</div>
				<Divider />
				<div
					onClick={() => setOpenOrderHistory(!openOrderHistory)}
					className="flex flex-row gap-2"
				>
					{openOrderHistory ? <p>{"▼"}</p> : <p>{"▶"}</p>}

					<p> {strings?.orderHistroy}</p>
				</div>
				{openOrderHistory && (
					<Steps
						progressDot
						current={10}
						direction="vertical"
						items={orderHistory}
					/>
				)}
				{isClient && rowData?.statusId === orderStatuses.DELIVERED && (
					<>
						<Divider />
						<div className="flex justify-end">
							<Button
								onClick={onReturnOrderClick}
								size="large"
								type="primary"
								style={{
									backgroundColor: "#4F16C2",
									width: 182,
								}}
							>
								{strings?.orderReturn}
							</Button>
						</div>
					</>
				)}
			</Modal>
			<Modal
				title={strings?.titleChangeTransportCost}
				open={modalTransportPrice}
				onCancel={() => setModalTransportPrice(false)}
				okButtonProps={{ className: "bg-blue-500" }}
				width={720}
				footer={() => (
					<>
						<div className="flex">
							<Buttons
								button1Text={strings?.buttons.close}
								button2Text={strings?.buttons.saveChanges}
								onButton1Click={() =>
									setModalTransportPrice(false)
								}
								onButton2Click={updateTransportPriceHandler}
							/>
						</div>
					</>
				)}
			>
				<div className="transportModalMainContainer">
					<div className="transportModalFirstContainer">
						<p className="font-normal">{strings?.selectedOrders}</p>
						{selectedOrderIds?.map((order, index) => (
							<div
								key={index}
								className="transportModalOrderContainer"
							>
								<p className="transportModalOrderId">
									#{order.id}
								</p>
								<div className="statusTransportModalDiv">
									<p
										className="rounded-[70px] flex justify-center items-center h-[30px] gap-[6px] w-fit   p-2"
										style={{
											backgroundColor: order.statusColor
												? hexToRgba(
														order.statusColor,
														0.08
												  )
												: "#ffff",
											color: order.statusColor || "#000",
										}}
									>
										{"\u25CF"} {order.status}
									</p>
								</div>
								<div className="transportModalName">
									<p className="font-semibold">
										{order.name}
									</p>
									<p className="text-[#4F16C2]">
										{order.phone}
									</p>
								</div>
								<p className="transportModalCity">
									{order.city}
								</p>
								<p className="font-semibold w-[5%]">
									{order.packagePrice}{" "}
									{currencySymbol(order.currencyId)}
								</p>
							</div>
						))}
						<div className="line"></div>
					</div>
					<div className="transportModalSecondContainer">
						<DefaultInput
							label={strings?.changeTransportCost}
							className="transportModalInput"
							placeholder={strings?.changeTransportCost}
							onChange={(e) => setTransportCost(e.target.value)}
						/>
					</div>
					<div className="w-full flex rounded-md border border-purple-200 bg-purple-50 p-4 gap-4">
						<InfoIcon width={80} />
						<div>
							<p className={classes.secondTitle}>
								{strings?.note}
							</p>
							<p className={classes.info}>
								{strings?.transportCostNote}
							</p>
						</div>
					</div>
				</div>
			</Modal>
			<Modal
				open={changeOrderPriceOpen}
				onCancel={onCloseChangeOrderPrice}
				// onOk={confirmRollBack}
				title={strings?.changeOrderPriceTitle}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
			>
				<Divider />
				<div className="flex flex-col rounded-lg border-2 border-slate-100">
					<OrderDetailRow
						label={strings?.packagePrice}
						value={formatMoney(
							rowData?.orderPrice,
							rowData?.currencyId
						)}
						className="driverDetailRow"
					/>
				</div>
				<Divider />
				<div>
					<DefaultInput
						onChange={onNewOrderPriceForReturnChange}
						value={newOrderPriceForReturn}
						label={strings?.newPackagePriceLabel}
						placeholder={rowData?.orderPrice.toFixed(2)}
						// type="number"
						min={0}
					/>
				</div>
				<Divider />
				<div className="flex justify-end">
					<Button
						onClick={onChangeOrderPriceClick}
						size="large"
						type="primary"
						disabled={isChangingOrderPrice}
						style={{
							backgroundColor: "#4F16C2",
							width: 182,
						}}
					>
						{strings?.createOrderReturnButton}
					</Button>
				</div>
			</Modal>
			<Modal
				title={strings?.createOrderReturnButton}
				open={isWaitingForPickupModalOpen}
				onOk={handleClientStatusChangeToWaitingPickup}
				onCancel={() => setIsWaitingForPickupModalOpen(false)}
				okButtonProps={{ className: "bg-blue-500" }}
			>
				{/* <p>
						Ju lutem komfirmoni se porosia juaj është gati për
						grumbulli dhe mund te mbledhet nga posta.
					</p> */}
			</Modal>
			<Modal
				open={openChangeStatusToPreviousModal}
				onCancel={() => setOpenChangeStatusToPreviousModal(false)}
				onOk={orderStatusChangeToPreviousStatus}
				title={strings?.confirm}
				okButtonProps={{ className: "bg-blue-500" }}
			>
				<p>{strings?.confirmRemoveOrderFromCollection}</p>
			</Modal>
			<Modal
				open={openDeleteOrdersConfirmationModal}
				onCancel={() => setOpenDeleteOrdersConfirmationModal(false)}
				onOk={deleteSelectedOrders}
				title={strings?.confirm}
				okButtonProps={{ className: "bg-blue-500" }}
			>
				<p>
					A jeni te sigurte se deshironi te i fshini nga sistemi
					porosite e zgjedhura?
				</p>
			</Modal>
		</>
	);
};

export default Orders;

const style = {
	oddRow: { backgroundColor: "#F9F8FC" },
	modalUnderTitles: {
		fontSize: 18,
		color: "#1B4965",
	},
	//fix width
	selectedOrder: {
		backgroundColor: "#4f16c2",
		fontSize: 18,
		color: "white",
		width: 50,
		borderRadius: 4,
	},
};
